/*
 * Jira Ticket:
 * Created Date: Thu, 19th Nov 2020, 19:28:58 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { DeleteButton, SaveButton, Toolbar, useNotify } from 'react-admin';
import { toolbarStyles } from 'styles';

const SanitizedDeleteButton = ({
  dialogTitle,
  dialogContent,
  onSave,
  ...rest
}) => {
  const title = dialogTitle ? dialogTitle : 'Delete item';
  const content = dialogContent
    ? dialogContent
    : 'Are you sure want to delete this item?';

  return (
    <DeleteButton {...rest} confirmTitle={title} confirmContent={content} />
  );
};

const MultiLanguageToolbar = ({
  dialogTitle,
  dialogContent,
  iscompleted,
  invalid,
  isInvalid,
  ...props
}) => {
  const {
    hideDelete = false,
    className,
    onSave,
    redirect,
    deleteRedirect = 'list',
    extend,
    enableNotification = false,
    additionalToolbarComponents = null,
    ...rest
  } = props;
  const classes = toolbarStyles(extend);
  const notify = useNotify();
  return (
    <Toolbar className={classes.root} {...rest}>
      <SaveButton
        invalid={isInvalid}
        redirect={redirect}
        disabled={iscompleted}
        onClick={() =>
          // for some reason in a tabbed form the notification does not appear when invalid
          enableNotification &&
          isInvalid &&
          notify('ra.message.invalid_form', 'warning')
        }
      />
      {additionalToolbarComponents}
      {hideDelete ? null : (
        <SanitizedDeleteButton
          redirect={deleteRedirect}
          mutationMode="pessimistic"
          dialogTitle={dialogTitle}
          dialogContent={dialogContent}
          {...props}
        />
      )}
    </Toolbar>
  );
};

export default MultiLanguageToolbar;
